export function handleKeyDown(e) {
  const key = e.key;
  const isValidKey =
    /^[a-zA-Z0-9_]*$/.test(key) || ["Backspace"].includes(e.key);

  if (!isValidKey) {
    e.preventDefault();
  }
}

export function handlePaste(e) {
  const paste = e.clipboardData.getData("text");
  const isValidKey = /^[a-zA-Z0-9_]*$/.test(paste);

  if (!isValidKey) {
    e.preventDefault();
  }
}

export function handleKeyDownForPasswordInput(e) {
  const arabicPattern =
    /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/u.test(
      e.key,
    );
  const whitespacePattern = /^\s$/.test(e.key);

  if (arabicPattern || whitespacePattern) {
    e.preventDefault();
  }
}

export function handlePasteForPasswordInput(e) {
  const paste = e.clipboardData.getData("text");
  const arabicPattern =
    /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/u.test(
      paste,
    );
  const whitespacePattern = /^\s$/.test(paste);

  if (arabicPattern || whitespacePattern) {
    e.preventDefault();
  }
}

export function handleKeyDownForPhoneNumberInput(e) {
  const pattens = /^[0-9]*$/.test(e.key) || ["Backspace"].includes(e.key);

  if (!pattens) {
    e.preventDefault();
  }
}

export function handlePasteForPhoneNumberInput(e) {
  const paste = e.clipboardData.getData("text");
  const pattens = /^[0-9]*$/.test(paste);

  if (!pattens) {
    e.preventDefault();
  }
}

export function clickToSubmitButtonWithEnter() {
  const handleKeydown = (e) => {
    if (e.key === "Enter") {
      const submitButton = document.querySelector(".submit_button");
      if (submitButton) {
        submitButton.click();
      }
    }
  };

  window.addEventListener("keydown", handleKeydown);

  return () => {
    window.removeEventListener("keydown", handleKeydown);
  };
}


export function handleKeyDownEmailInput(e, ) {

  const patterns = /^[A-Za-z0-9@\-_.]$/.test(e.key)

  if (!patterns && !['Backspace', 'Delete'].includes(e.key)) {
    e.preventDefault();
  }

}

export function handleChangeEmailInput(e, setEmailInputError) {
  if (e.includes('@') && e.includes('.')) {
    setEmailInputError(false);
  } else {
    setEmailInputError(true)
  }
}

export function handleKeyDownUsernameInput(e) {
  const patterns = /^[A-Za-z0-9]$/.test(e.key)

  if (!patterns && !['Backspace', 'Delete'].includes(e.key)) {
    e.preventDefault();
  }

} 


export function handleChangeNumberInput(value, setCodeInputError) {
  const parrent = /^[0-9]*$/.test(value);

  if (!parrent) {
    setCodeInputError(true);
  } else {
    setCodeInputError(false);
  }
} 